import { useEffect, useState } from "react";

const useScreenSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Call once to avoid layout shift before resize
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size; // { width, height }
};

export default useScreenSize;
